export const CustomLoader = (): JSX.Element => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "30vh",
        // background: "#f4f4f9",
        marginTop: "15px",
      }}
    >
      <div
        style={{
          width: "38px",
          height: "38px",
          border: "4px solid #ddd",
          borderTop: "4px solid var(--primary-color)",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />
      <style>
        {`
          @keyframes spin {
            0%   { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export const CustomLoaderSmall = ({ size = "" }): JSX.Element => {
  return (
    <div
      style={{
        display: "flex",
        // justifyContent: "center",
        alignItems: "center",
        // height: "100vh",
        // background: "#f4f4f9",
        // marginTop: "",
        paddingLeft: size ? "" : "20px",
      }}
    >
      <div
        style={{
          width: size ? size : "24px",
          height: size ? size : "24px",
          // height: `${size ?  : "24px"}`,
          // height: `${size ?  : "24px"}`,
          border: `${size ? "2px" : "3px"} solid #ddd`,
          borderTop: `${size ? "2px" : "3px"} solid var(--primary-color)`,
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />
      <style>
        {`
          @keyframes spin {
            0%   { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};
